import { defineMessage, defineMessages } from "react-intl";

export const exportMessages = defineMessages({
  button: { id: "exports.button", defaultMessage: "Export CSV" },
  viewExports: { id: "exports.viewExports", defaultMessage: "Exports" },
  preciseIncluded: {
    id: "exports.precise.included",
    defaultMessage: "The file includes precise coordinates, because you hold that permission.",
  },
  preciseExcluded: {
    id: "exports.precise.excluded",
    defaultMessage:
      "The file has no precise coordinates: they need the precise location permission.",
  },
  backgroundTitle: { id: "exports.background.title", defaultMessage: "Export in progress" },
  backgroundBody: {
    id: "exports.background.body",
    defaultMessage:
      "This list is large, so the file is generated in the background. We will notify you when it is ready.",
  },
  failedTitle: { id: "exports.failed.title", defaultMessage: "We could not export the list" },
  dialogTitle: { id: "exports.dialog.title", defaultMessage: "Your exports" },
  dialogClose: { id: "exports.dialog.close", defaultMessage: "Close" },
  dialogDescription: {
    id: "exports.dialog.description",
    defaultMessage: "Files are kept for 7 days. Download links are valid for 5 minutes.",
  },
  tableCaption: { id: "exports.table.caption", defaultMessage: "Exports requested by you" },
  empty: { id: "exports.empty", defaultMessage: "You have not exported anything yet." },
  loadMore: { id: "exports.loadMore", defaultMessage: "Load more" },
  colKind: { id: "exports.col.kind", defaultMessage: "List" },
  colRequested: { id: "exports.col.requested", defaultMessage: "Requested" },
  colStatus: { id: "exports.col.status", defaultMessage: "Status" },
  colRows: { id: "exports.col.rows", defaultMessage: "Rows" },
  colExpires: { id: "exports.col.expires", defaultMessage: "Available until" },
  colAction: { id: "exports.col.action", defaultMessage: "Action" },
  download: { id: "exports.download", defaultMessage: "Download" },
});

export const exportKindMessages = defineMessages({
  users: { id: "exports.kind.users", defaultMessage: "Users" },
  devices: { id: "exports.kind.devices", defaultMessage: "Devices" },
  user_transactions: { id: "exports.kind.userTransactions", defaultMessage: "Player transactions" },
  device_transactions: {
    id: "exports.kind.deviceTransactions",
    defaultMessage: "Device transactions",
  },
  ip_transactions: { id: "exports.kind.ipTransactions", defaultMessage: "IP transactions" },
});

export const exportStatusMessages = defineMessages({
  requested: { id: "exports.status.requested", defaultMessage: "Waiting" },
  running: { id: "exports.status.running", defaultMessage: "Generating" },
  ready: { id: "exports.status.ready", defaultMessage: "Ready" },
  failed: { id: "exports.status.failed", defaultMessage: "Failed" },
  expired: { id: "exports.status.expired", defaultMessage: "Expired" },
});

export const csvDownloadedMessage = defineMessage<{ filename: string }>({
  id: "exports.csvDownloaded",
  defaultMessage: "{filename} was downloaded.",
});
